import type { JSX } from "react";
import { Menu } from "lucide-react";

export interface HeaderProps {
  appName: string;
  onOpenMenu: () => void;
}

export function Header({ appName, onOpenMenu }: HeaderProps): JSX.Element {
  return (
    <header className="sticky top-0 z-30 h-20 border-b border-gray-100 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex h-full w-full max-w-7xl items-center justify-between px-6 lg:px-10">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onOpenMenu}
            aria-label={`打开 ${appName} 导航`}
            className="rounded-2xl p-3 text-gray-500 transition-colors hover:bg-gray-100 hover:text-black lg:hidden"
          >
            <Menu size={24} />
          </button>

          <p className="hidden text-[11px] font-black uppercase tracking-[0.32em] text-gray-300 lg:block">
            {appName}
          </p>
        </div>

        <div className="ml-auto flex items-center gap-4 sm:gap-6">
          <div className="text-right">
            <p className="text-sm font-black uppercase tracking-[0.24em] text-black">
              Premium Merchant
            </p>
            <p className="text-xs font-bold text-gray-400">xuekuangyi@gmail.com</p>
          </div>

          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-black text-sm font-black text-white shadow-xl shadow-black/10">
            PM
          </div>
        </div>
      </div>
    </header>
  );
}
